module.exports = __webpack_public_path__ + "assets/images/icons/ageing-0.svg?v=80f69a6a";